import { environment, ENVS } from './environment';

const DEV = ENVS.development.name;
const STG = ENVS.staging.name;
const PROD = ENVS.production.name;
const ALL = [DEV, STG, PROD];

const FLAGS_CONFIG = {
  creators: ALL,
  creatorsSerieView: ALL,
  communitySection: [],
  cast: [DEV]
}

const isFlagEnabled = (flag) => {
  if (!FLAGS_CONFIG[flag]) {
    console.error(`You're using an invalid flag: ${flag}`)

    const validFlags = Object.keys(FLAGS_CONFIG).join(', ')
    console.error(`valid flags are: ${validFlags}`)
    return
  }

  const currentEnv = environment.name;
  const isEnabled = FLAGS_CONFIG[flag].includes(currentEnv)

  return isEnabled;
}

export const FLAGS = {
  isCreatorsEnabled: isFlagEnabled('creators'),
  isCreatorsSerieViewEnabled: isFlagEnabled('creatorsSerieView'),
  isCommunitySectionEnabled: isFlagEnabled('communitySection'),
  isCastEnabled: isFlagEnabled('cast'),
}